import {autofill} from "@mapbox/search-js-web";

autofill({
	accessToken: "pk.eyJ1IjoiaG9ydG9ubWFwYm94IiwiYSI6ImNsejFoYjJ6bTAwY2wyanB1bGl5MzlzbjQifQ.1uwWy0n3btmQg0p5Fd3g-Q",
	options: {
		country: "us"
	},
	browserAutofillEnabled: true
});
